import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import { tutorialProgressResourceType } from "./tutorialProgressResourceConsts";

export const tutorialProgressIdentifierStruct = createIdentifierStruct(
  tutorialProgressResourceType
);
